import { Component, ChangeDetectionStrategy} from '@angular/core';

@Component({ standalone: false,
    selector: 'dux-blended-sec-alloc-group-cell',
    template: `
        <div style="text-overflow: ellipsis;">
          @if (conflict || conflictWsa) {
            <span>
              <img style="cursor:pointer;margin-right:3px;" (click)="$event.stopPropagation()" src="/assets/images/exclamation-triangle.png" calltoaction calltoactionPosition="top" [calltoactionTemplate]="irbColInfoTemplateRef">
              <ng-template #irbColInfoTemplateRef >
                <div class="block">
                  <b>Trading Rules Conflict</b>
                  <div>This security has a target in more than one of the security models included in this blended model. The security has different trading rules (such as minimums or equivalents) for the security models. Because of this conflict, this blended model will use this security's trading rules from the security master.</div>
                </div>
              </ng-template>
            </span>
          }
          @if (!params.data.parentChildId) {
            <span>{{params.value}}</span>
          }
          <div style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
            <span tooltip [tooltipTitle]="params.value"
              [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true'
            [tooltipHorizontalOffset]='10'>{{params.value}}</span>
          </div>
        </div>
        `,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class BlendedSecurityAllocationGroupcellComponent {
    params: any = {};
    conflict = false;
    conflictWsa = false;
    
    agInit(params: any): void {
        this.params = params;
        this.conflict = this.params.data.conflict ? true : false;
        this.conflictWsa = this.params.data.conflictWsa ? true : false;
    }
    refresh(): boolean {
        return true;
    }
}
